import React from 'react';
import { motion } from 'framer-motion';

const PartnersSection: React.FC = () => {
  const partners = [
    {
      id: 'ministry-of-health',
      name: 'Ministry of Health',
      logo: '/images/Global Partners/Logos/Ministry of health.jpeg',
      description: 'Government Partnership',
      website: 'https://www.moh.go.tz'
    },
    {
      id: 'msd',
      name: 'MSD',
      logo: '/images/Global Partners/Logos/MSD logo.svg',
      description: 'Strategic Partner',
      website: 'https://www.msd.com'
    },
    {
      id: 'ivoclar',
      name: 'Ivoclar Vivadent',
      logo: '/images/Global Partners/Logos/ivoclar-logo.svg',
      description: 'Manufacturing Partner',
      website: 'https://www.ivoclar.com'
    },
    {
      id: 'vatech',
      name: 'Vatech',
      logo: '/images/Global Partners/Logos/vatech.png',
      description: 'Technology Partner',
      website: 'https://www.vatech.com'
    },
    {
      id: 'bms-dental',
      name: 'BMS Dental',
      logo: '/images/Global Partners/Logos/BMS.png',
      description: 'Dental Solutions Partner',
      website: 'https://www.bmsdental.com'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Partners
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We work with leading organizations and manufacturers to bring you the highest quality dental solutions
          </p>
        </motion.div>

        <div className="overflow-hidden">
          <motion.div
            className="flex gap-12 items-center"
            animate={{
              x: [0, -100 * partners.length],
            }}
            transition={{
              duration: 20,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {/* First set of logos */}
            {partners.map((partner, index) => (
              <motion.div
                key={`first-${partner.id}`}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ 
                  duration: 0.8, 
                  delay: index * 0.1,
                  type: "spring",
                  stiffness: 100,
                  damping: 15
                }}
                className="flex-shrink-0"
              >
                <a
                  href={partner.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block hover:scale-110 transition-transform duration-300"
                  title={`Visit ${partner.name} website`}
                >
                  <img
                    src={partner.logo}
                    alt={`${partner.name} Logo`}
                    className="w-24 h-24 object-contain"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = '/images/Global Partners/Logos/default-partner.svg';
                    }}
                  />
                </a>
              </motion.div>
            ))}
            
            {/* Duplicate set for seamless loop */}
            {partners.map((partner, index) => (
              <motion.div
                key={`second-${partner.id}`}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ 
                  duration: 0.8, 
                  delay: (index + partners.length) * 0.1,
                  type: "spring",
                  stiffness: 100,
                  damping: 15
                }}
                className="flex-shrink-0"
              >
                <a
                  href={partner.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block hover:scale-110 transition-transform duration-300"
                  title={`Visit ${partner.name} website`}
                >
                  <img
                    src={partner.logo}
                    alt={`${partner.name} Logo`}
                    className="w-24 h-24 object-contain"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = '/images/Global Partners/Logos/default-partner.svg';
                    }}
                  />
                </a>
              </motion.div>
            ))}
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default PartnersSection;
